import classNames from 'classnames';
import { DropdownList } from 'react-widgets';
import * as React from 'react';
import styles from 'src/components/assets/simple-table.module.scss';
import { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import SeanceEnum from 'src/enumerables/seance-enum';
import { withoutHiddenStatuses } from 'src/helpers/seance/seanceStatus';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { asyncPersistSeance } from 'src/store/actions/seance-actions';
import { Dispatch } from 'redux';
import { StoreState } from '../../../../../../../../../store/reducers';
import { changeToZeroZoneDate } from 'src/helpers/timeHelpers';
import Loader from '../../../../../../../../../components/Loader';
import { getServiceTypes } from '../../../../../../../../../store/actions/service-type-actions';
import { getServiceLocations } from '../../../../../../../../../store/actions/service-location-actions';
import { QueryParams } from '../../../../../../../../../types/grid';
import { IServiceType } from '../../../../../../../../../types/service-types';
import { Paginated } from '../../../../../../../../../services/api-handlers/pagination';
import CaseEnum from '../../../../../../../../../enumerables/case-enum';
import { IServiceLocation } from '../../../../../../../../../types/service-locations';
import { IProvider } from '../../../../../../../../../types/provider';
import { toast } from 'react-toastify';
import moment from 'moment';
import getColumnChange from '../helpers/ColumnChange';

export interface StateProps {
    inProgress: boolean;
    serviceTypes: Paginated<IServiceType>;
    serviceLocations: Paginated<IServiceLocation>;
}

export interface DispatchProps {
    updateData: (val: any) => Promise<any>;
    getServiceTypes: (param: QueryParams) => void;
    getServiceLocations: (param: QueryParams) => void;
}

export interface OwnProps {
    columns: { id: string; label: string; type?: string; cellStyle: string }[];
    row: any;

    key: string;
    action: (val: any) => void;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}
export interface State {
    id?: string | number;
    occasion?: string | number;
    seanceDate: Date;
    startTime: Date;
    endTime: Date;
    isWeekly: any;
    provider: Partial<IProvider>;
    goals?: string;
    problem?: string;
    attendance?: string;
    plan?: string;
    isTelehealth?: boolean;
    totalUnit: string;
    seanceInfo: string;
    totalFee: string;
    providerId?: string;
    columnForm?: boolean;
    status: { label: string; value: number };
    minPerUnit: { label: string; value: number };
    serviceType: { label: string; value: number };
    serviceLocation: { label: string; value: number };
}
const statusEnum = SeanceEnum ? SeanceEnum.getEnum('SeanceStatus') : {};
const statusItems: SelectObject[] = getValFromEnum(statusEnum);
class FormColumn extends React.Component<Props, any> {
    constructor(props: any) {
        super(props);

        let start: any = '';
        let end: any = '';
        if (props.row.startTime && moment(props.row.startTime, 'YYYY-MM-DD HH:mm:ss').isValid()) {
            start = moment(props.row.startTime, 'YYYY-MM-DD HH:mm:ss').toDate();
        } else {
            start = changeToZeroZoneDate(props.row.startTime);
        }
        if (props.row.endTime && moment(props.row.endTime, 'YYYY-MM-DD HH:mm:ss').isValid()) {
            end = moment(props.row.endTime, 'YYYY-MM-DD HH:mm:ss').toDate();
        } else {
            end = changeToZeroZoneDate(props.row.endTime);
        }

        const { existData, setExistData } = this.props.row;

        this.state = {
            id: '',
            totalUnit: '',
            totalFee: '',

            status: { label: 'one', value: 1 },

            minPerUnit: null,
            ...props.row,
            seanceInfo: props.row?.seanceInfo ? props.row?.seanceInfo : '',
            serviceLocation: props.row?.serviceLocation?.id
                ? { value: props.row.serviceLocation?.id, label: props.row.serviceLocation?.title }
                : null,
            serviceType: props.row?.serviceType
                ? { value: props.row.serviceType?.id, label: props.row.serviceType?.title }
                : null,
            seanceDate: props.row.seanceDate ? changeToZeroZoneDate(props.row['seanceDate']) : undefined,
            startTime: props.row.startTime ? start : undefined,
            endTime: props.row.endTime ? end : undefined,
        };
    }
    static getDerivedStateFromProps(nextProps: any, prevState: State): State {
        const newState = prevState;
        statusItems.forEach((it) => {
            if (+it.value === +prevState.status) {
                newState.status = it;
            }
        });

        return newState;
    }

    handleChange = (event: ChangeEvent<HTMLInputElement>, name: string) => {
        this.setState({ ...this.state, [name]: event.target.value });
    };
    handleSubmit = async () => {
        let status: any = this.state.status;
        if (this.state.status?.label) {
            status = status?.value;
        }

        if (this.state.endTime.getTime() === this.state.startTime.getTime()) {
            toast.error('Incorrect time!');
        } else {
            await this.props.updateData({ ...this.state, status });
            return this.props.action(false);
        }
    };
    render() {
        const MinPerUnit = CaseEnum ? CaseEnum.getEnum('MinPerUnit') : {};
        const minPerUnitData: SelectObject[] = getValFromEnum(MinPerUnit);
        const { occasion, setOpenDrop } = this.props.row;
        const serviceTypeData: any = [];
        const serviceLocationData: any = [];
        const { signDoc } = this.props.row;

        let canConfirm = true;
        statusItems.forEach((it) => {
            if (it.value === 4 && !signDoc) {
                canConfirm = false;
            }
        });
        if (!canConfirm || !this.state['id']) {
            statusItems.forEach((it, l) => {
                if (it.value === 4) {
                    statusItems.splice(l, 1);
                }
            });
        }
        this.props.serviceTypes.list.forEach((itS) => {
            serviceTypeData.push({ value: itS.id, label: itS.title ? itS.title : itS.cpt });
        });

        this.props.serviceLocations.list.forEach((itS) => {
            serviceLocationData.push({ value: itS.id, label: itS.title });
        });
        const columnChange: any = getColumnChange({
            component: this,
            setOpenDrop: setOpenDrop,
            occasion,
            statusItems: withoutHiddenStatuses(statusItems),
        });
        if (this.props.row?.occasion?.caseType === 2 || this.props.row?.occasion?.caseType === 3) {
            columnChange.serviceType = (
                <div style={{ minWidth: 215 }}>
                    <DropdownList
                        data={serviceTypeData}
                        textField="label"
                        valueField="value"
                        onChange={(item: SelectObject) => {
                            this.setState({ ...this.state, serviceType: item });
                        }}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                        dropUp
                        value={this.state.serviceType}
                    />
                </div>
            );
            columnChange.serviceLocation = (
                <div style={{ minWidth: 215 }}>
                    <DropdownList
                        data={serviceLocationData}
                        textField="label"
                        valueField="value"
                        onChange={(item: SelectObject) => {
                            this.setState({ ...this.state, serviceLocation: item });
                        }}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                        dropUp
                        value={this.state.serviceLocation}
                    />
                </div>
            );
            columnChange.minPerUnit = (
                <div style={{ minWidth: 215 }}>
                    <DropdownList
                        data={minPerUnitData}
                        textField="label"
                        valueField="value"
                        onChange={(item: SelectObject) => {
                            this.setState({ ...this.state, minPerUnit: item });
                        }}
                        onToggle={(isOpen) => {
                            if (isOpen) {
                                setOpenDrop(true);
                            } else {
                                setOpenDrop(false);
                            }
                        }}
                        dropUp
                        value={this.state.minPerUnit}
                    />
                </div>
            );
        }
        if (this.props.row?.occasion?.caseType === 3) {
            columnChange.seanceInfo = (
                <div style={{ minWidth: 215 }}>
                    <input
                        type="text"
                        className={classNames('form-control', 'input-sm')}
                        onChange={(event) => {
                            this.setState({ ...this.state, seanceInfo: event.target.value });
                        }}
                        value={this.state.seanceInfo}
                    />
                </div>
            );
        }

        return (
            <div className={classNames(styles.relative)}>
                {this.props.columns.map(
                    (column: { id: string; label: string; type?: string; cellStyle: string }, key) => (
                        <div
                            style={{ minHeight: 50, fontSize: 14 }}
                            className={
                                'border-secondary text-center  d-flex justify-content-center align-items-center border border-bottom-1'
                            }
                            key={`td-${key}`}
                        >
                            {columnChange[column.id]}
                        </div>
                    ),
                )}
                <div className={classNames(styles.hide)}>{this.props.inProgress ? <Loader /> : ''}</div>
            </div>
        );
    }
}
function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.seances.inProgress,
        serviceTypes: state.serviceTypes.data,
        serviceLocations: state.serviceLocations.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        updateData: async (data: any) => {
            const locationType = data.serviceLocation ? data.serviceLocation : null;
            const serviceType = data.serviceType ? data.serviceType : null;

            return await asyncPersistSeance(
                {
                    ...data,
                    serviceLocation: locationType,
                    serviceType,
                    occasion: data.occasion?.id,
                    columnForm: true,
                    isWeekly: false,
                },
                {},
                dispatch,
            );
        },
        getServiceTypes: async (params: QueryParams) => await dispatch(getServiceTypes(params)),
        getServiceLocations: async (params: QueryParams) => await dispatch(getServiceLocations(params)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FormColumn);
